import * as React from 'react';

/**
 * One "field changed from X to Y" line.
 *
 * This replaces the GetLogs component, which fetched the same three values from
 * /cvl on mount and held them in local state. The values now arrive on the
 * entry, so the row is a pure render with no request, no loading state and no
 * per-row cache in the reducer.
 *
 * The values are still injected as HTML: they are formatted server-side by the
 * same code path the log tab uses, which emits markup for some field types.
 */
export default function ChangeRow({ change }) {
    if (!change || !change.field) {
        return null;
    }

    const oldValue = change.from_value;
    const newValue = change.to_value;

    // "added" reads better than "changed" when there was no prior value, which
    // is what the log tab shows for a first-time entry.
    const verb = oldValue ? "changed from" : "added from";

    return (
        <li className="logs_listing_items">
            <div className="log-block">
                <div className="log-detail">
                    <ul>
                        <li>
                            <div className="rowFlex alignMiddle">
                                <div className="log-head">
                                    <span className="changed_field">{change.field}</span> {verb}
                                </div>
                            </div>
                            {oldValue
                                ? <label dangerouslySetInnerHTML={{ __html: oldValue }}></label>
                                : <label>-</label>}
                        </li>
                        <li>
                            <label>to</label>
                            {newValue
                                ? <span dangerouslySetInnerHTML={{ __html: newValue }}></span>
                                : <span>-</span>}
                        </li>
                    </ul>
                </div>
            </div>
        </li>
    );
}
